import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { PRIORITY_TYPE } from '@atlassian/jira-platform-field-config';
import type { Priority } from '../../../model/priority/types';
import { type CardSetMeta, setCardSetMeta } from '../meta/card-set-meta';

export const LOAD_PRIORITIES_REQUEST = 'state.actions.priorities.LOAD_PRIORITIES_REQUEST' as const;

export type LoadPrioritiesAction = {
	type: typeof LOAD_PRIORITIES_REQUEST;
};

export const loadPriorities = (): LoadPrioritiesAction => ({
	type: LOAD_PRIORITIES_REQUEST,
});

export const LOAD_PRIORITIES_SUCCESS = 'state.actions.priorities.LOAD_PRIORITY_SUCCESS' as const;

export type LoadPrioritiesSuccessAction = {
	type: typeof LOAD_PRIORITIES_SUCCESS;
	payload: Priority[];
};

export const loadPrioritiesSuccess = (response: Priority[]) => ({
	type: LOAD_PRIORITIES_SUCCESS,
	payload: response,
});

export const LOAD_PRIORITIES_FAILURE = 'state.actions.priorities.LOAD_PRIORITY_FAILURE' as const;

export type LoadPrioritiesFailureAction = {
	type: typeof LOAD_PRIORITIES_FAILURE;
};

export const loadPrioritiesFailure = () => ({
	type: LOAD_PRIORITIES_FAILURE,
});

export const CARD_PRIORITY_SET = 'state.actions.priorities.CARD_PRIORITY_SET';

export type CardPrioritySetAction = {
	type: typeof CARD_PRIORITY_SET;
	payload: {
		cardId: number;
		priority: Priority;
	};
};

export const cardPrioritySet = (
	payload: CardPrioritySetAction['payload'],
): CardPrioritySetAction => ({
	type: CARD_PRIORITY_SET,
	payload,
});

export const CARD_PRIORITY_SET_OPTIMISTIC = 'state.actions.priorities.CARD_PRIORITY_SET_OPTIMISTIC';

export type CardPrioritySetOptimisticAction = {
	type: typeof CARD_PRIORITY_SET_OPTIMISTIC;
	payload: CardPrioritySetAction['payload'];
	meta: CardSetMeta;
};

export const cardPrioritySetOptimistic = (
	payload: CardPrioritySetOptimisticAction['payload'],
	issueKey: string,
	analyticsEvent: UIAnalyticsEvent,
): CardPrioritySetOptimisticAction => ({
	type: CARD_PRIORITY_SET_OPTIMISTIC,
	payload,
	meta: {
		...setCardSetMeta(
			{
				fieldId: PRIORITY_TYPE,
				issueKey,
				newValue: payload.priority,
				retryAction: () => cardPrioritySetOptimistic(payload, issueKey, analyticsEvent),
			},
			analyticsEvent,
		),
	},
});

export type Action =
	| LoadPrioritiesAction
	| LoadPrioritiesSuccessAction
	| LoadPrioritiesFailureAction
	| CardPrioritySetOptimisticAction
	| CardPrioritySetAction;
